exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn i.icon[data-v-3c1bb60f] {\n  padding-right: 5px;\n}", ""]);

// exports
